import React from 'react';

import { Controller } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

function CusSelectFieldManual({
	itemGrid,
	name,
	label,
	options,
	control,
	fieldStyle,
	multiple,
	placeholder,
	defaultValue,
	type
}) {
	return (
		<Grid item xs={12} sm={itemGrid}>
			<Controller
				name={name}
				control={control}
				defaultValue={defaultValue}
				color="primary"
				render={({ field }) => (
					<TextField
						defaultValue={defaultValue}
						className={fieldStyle}
						type={type}
						placeholder={placeholder}
						{...field}
						label={label}
						variant="standard"
					/>
				)}
			/>
		</Grid>
	);
}

export default React.memo(CusSelectFieldManual);
